import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/6-1_signout.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const SignOutAlt: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default SignOutAlt;
